export const headerCellStyles = {
    color: '#444',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '700',
    background: '#DAEDFE',
    height: '36px',
    padding:'6px 12px'
}

export const cellStyles = {
    whiteSpace: 'nowrap',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    alignItems:'center',
    padding:'7px 12px',
    minHeight:'36px',
    color: '#444',
    // justifyContent: 'center',
    //  textAlign: 'center'
}
export const branchTypeList = [{ id: 0, name: 'All' }, { id: 1, name: 'Own' }, { id: 2, name: 'Other' }]
export const monthNamesList = [
    {id:1,name:'January'},
    {id:2,name:'February'},
    {id:3,name:'March'},
    {id:4,name:'April'},
    {id:5,name:'May'},
    {id:6,name:'June'},
    {id:7,name:'July'},
    {id:8,name:'August'},
    {id:9,name:'September'},
    {id:10,name:'October'},
    {id:11,name:'November'},
    {id:12,name:'December'},
  ]
export const getYearList=(startYear,endYear)=>{
    let yearList = []
    for (let year = startYear; year <= endYear; year++) {
        let obj = {
          year: year
        };
        yearList.push(obj)
      }
      return yearList 
}
